import {Component, Input} from '@angular/core';
import {FlexLayoutModule, FlexModule} from "@ngbracket/ngx-layout";
import {MatAccordion, MatExpansionPanel} from "@angular/material/expansion";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {NameValue} from "../../../../_model/name-value";


export interface ExtendableContent {
  title: string;
  value: string;
  subValue?: string;
  items: NameValue[],
  explain?: string
}

@Component({
  selector: 'app-extendable-card',
  standalone: true,
  imports: [
    FlexModule,
    MatAccordion,
    MatExpansionPanel,
    MatIconButton,
    FlexLayoutModule,
    MatIcon
  ],
  templateUrl: './extendable-card.component.html',
  styleUrl: './extendable-card.component.scss'
})
export class ExtendableCardComponent {
  @Input()
  content?: ExtendableContent
}
